import { useContext } from "react";
import styled from 'styled-components';
import { DataContext } from '../context/DataContext';

const Wrapper = styled.div`
  ${props => props.wrapperWidth && `width: ${props.wrapperWidth};`}
  display: flex;
  flex-direction: ${props => props.flexDirection};
  margin: 0 auto;
  justify-content: space-between;
  ${props => props.textAlign && `text-align: ${props.textAlign};`}

  ${props => props.padding && `padding: ${props.padding};`}
  @media (max-width: 768px) {
    width: 98%;
  }
`;

const MasterWrapper = ({ children, flexDirection, padding, textAlign }) => {
  const {
    wrapperWidth
  } = useContext(DataContext);

  return (
    <Wrapper wrapperWidth={wrapperWidth} flexDirection={flexDirection} padding={padding} textAlign={textAlign}>
      {children}
    </Wrapper>
  );
}

export default MasterWrapper;